import Layout from '@/layout';
import Router from 'vue-router';

export const asyncRouterMap = [
  {
    path: '/dashboardManagement',
    name: 'dashboardManagement',
    component: Layout,
    redirect: '/groupList',
    icon: 'dash-icon',
    children: [
      // {
      //   path: 'productList',
      //   name: 'productList',
      //   component: () => import('@/views/dashboardManagement/productList'),
      // },
      // {
      //   path: 'dashboardList',
      //   name: 'dashboardList',
      //   component: () => import('@/views/dashboardManagement/dashboardList'),
      // },
      {
        path: 'groupList',
        name: 'groupList',
        component: () => import('@/views/dashboardManagement/groupList.vue'),
      },
      {
        path: 'groupList/dashboardListByGroup',
        name: 'dashboardListByGroup',
        hidden: true,
        component: () =>
          import('@/views/dashboardManagement/dashboardListByGroup.vue'),
      },
    ],
  },
  {
    path: '/system',
    component: Layout,
    redirect: '/operationLog',
    icon: 'system-icon',
    name: 'system',
    children: [
      {
        path: 'operationLog',
        name: 'operationLog',
        component: () => import('@/views/system/operationLog'),
      },
      {
        path: 'loginLog',
        name: 'loginLog',
        component: () => import('@/views/system/loginLog'),
      },
      // {
      //   path: 'changeCompany',
      //   name: 'changeCompany',
      //   component: () => import('@/views/system/changeCompany'),
      // },
    ],
  },
];

const constantRouterMap = [
  {
    name: 'login',
    path: '/login',
    component: () => import('@/views/Login.vue'),
  },
  {
    path: '/organization',
    name: 'organization',
    component: () => import('@/views/organization/index'),
  },
  {
    path: '/404',
    name: 'fourToFour',
    component: () => import('@/views/404.vue'),
  },
  ...asyncRouterMap,
  {
    path: '*',
    redirect: '/404',
  },
];

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

const router = new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
});

export default router;
